module.exports = __webpack_public_path__ + "img/bg1.7b6e5752.png";